import React from "react";
import type { LucideIcon } from "lucide-react";
import { Plus } from "lucide-react";
import { Button } from "./button";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
	icon: LucideIcon;
	title: string;
	/** One line saying what belongs here, when the title alone does not. */
	description?: string;
	/** Primary next step, e.g. "Add department". Omit when the user cannot act (permissions, filters). */
	action?: { label: string; onClick: () => void };
	className?: string;
}

/** What a list shows when it has no rows: what is missing and, when possible, the next step. */
export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
	return (
		<div
			role="status"
			className={cn("flex flex-col items-center justify-center gap-2 px-4 py-10 text-center", className)}
		>
			<Icon className="h-10 w-10 text-muted-foreground" aria-hidden="true" />
			<p className="font-semibold">{title}</p>
			{description && <p className="max-w-md text-sm text-muted-foreground">{description}</p>}
			{action && (
				<Button variant="outline" className="mt-2" onClick={action.onClick}>
					<Plus className="h-4 w-4 me-2" />
					{action.label}
				</Button>
			)}
		</div>
	);
}
